<script setup lang="ts">
import BurgerIcon from '@/shared/ui/Icons/Burger.vue';
import MobileMenu from '@/widgets/mobileMenu/index';
import ArrowUpRightIcon from '@/shared/ui/Icons/ArrowUpRight.vue';
import LangButton from '@/widgets/header/ui/LangButton.vue';

const { t } = useI18n();
const localePath = useLocalePath();
const route = useRoute();

const isMobile = inject('isMobile');
const isMenuOpen = ref(false);

watch(
  () => route.fullPath,
  () => {
    isMenuOpen.value = false;
  },
);
</script>

<template>
  <div class="for-business-header">
    <div class="for-business-header__item _menu">
      <button
        v-if="isMobile"
        class="for-business-header__button"
        :aria-label="t('menu')"
        @click.prevent="isMenuOpen = !isMenuOpen"
      >
        <BurgerIcon class="for-business-header__icon" />
        <mobile-menu v-model="isMenuOpen" />
      </button>
      <nuxt-link
        class="for-business-header__link _logo"
        :to="localePath('/')"
        :aria-label="t('main')"
      >
        <NuxtImg
          class="for-business-header__logo"
          src="/images/logo.webp"
          alt="logo"
          preload
        />
      </nuxt-link>
    </div>
    <div class="for-business-header__item">
      <nuxt-link
        :to="localePath('catalog')"
        class="for-business-header__link _catalog"
        :aria-label="t('forBusinessPage.onlineStore')"
      >
        {{ t('forBusinessPage.onlineStore') }}
        <ArrowUpRightIcon class="for-business-header__icon _arrow" />
      </nuxt-link>
    </div>
    <div v-if="!isMobile" class="for-business-header__item _lang">
      <ClientOnly>
        <LangButton class="for-business-header__lang" />
      </ClientOnly>
      <a
        href="tel:+998712474545"
        class="for-business-header__link _phone"
        :aria-label="t('phoneNumber')"
      >
        +998 (71) 247-45-45
      </a>
    </div>
  </div>
</template>

<style lang="less">
.for-business-header {
  .container-d();

  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  &__logo {
    width: 132px;
    height: 39px;
  }

  &__lang {
    .lang-button__dropdown {
      right: 0;
      left: auto;
    }
  }

  &__item {
    display: flex;
    align-items: center;

    &._lang {
      .flex-column(@size-x5);

      align-items: flex-end;
    }
  }

  &__link {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    line-height: 100%;
    transition: color @A linear;

    &._catalog {
      gap: @size-x2;
      background-color: @color-athens-gray-dark;
      border-radius: @size-x5;
      padding: @size-x4 @size-x5;
    }

    &:hover {
      color: @color-tango;
    }

    &:hover .for-business-header__icon path {
      fill: @color-tango;
    }
  }

  &__button {
    .button-reset();

    display: inline-flex;
  }

  &__icon {
    width: 18px;
    height: 18px;

    &._arrow {
      width: 9px;
      height: 9px;
    }

    path {
      transition: fill @A linear;
    }
  }

  @media @1024 {
    padding: 0;

    &__logo {
      width: 100px;
      height: @size-x7;
    }

    &__item {
      &._menu {
        gap: @size-x3;
      }
    }

    &__link {
      font-size: 16px;

      &._catalog {
        font-size: 15px;
        padding: @size-x4 @size-x3;
      }
    }
  }
}
</style>
